import { combineReducers } from 'redux';

import applyCoupon from './applyCoupon';
import callbackReducer from './referralCallback';
import userReducer from './user';
import postTARatingReferralModalReducer from './postTARatingReferralModal';
import streakReferralModalReducer from './streakReferralModal';
import callbackReferralModalReducer from './callbackReferralModal';
import mentor from './mentorEligibility';
import coupons from './coupons';
import referral from './referral';

export const referralReducers = {
  callback: callbackReducer,
  user: userReducer,
  postTARatingReferralModal: postTARatingReferralModalReducer,
  streakReferralModal: streakReferralModalReducer,
  callbackReferralModalReducer,
  mentor,
  applyCoupon,
  coupons,
  referral,
};

const referralReducer = combineReducers(referralReducers);

export default referralReducer;
